import { render } from "./Mailgun.vue?vue&type=template&id=1cae4e87"
import script from "./Mailgun.vue?vue&type=script&lang=js"
export * from "./Mailgun.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__